<div class="flex flex-col h-full w-full gap-3 p-3 overflow-hidden">
    <div class="flex flex-col sm:flex-row items-start sm:items-center w-full justify-between gap-3 sm:gap-2">
        <div class="flex items-center  w-full gap-2"> <!-- min-w-0 ensures flex children can shrink -->
            <i class="pi pi-chevron-left cursor-pointer text-lg sm:text-xl" (click)="goBack()"></i>
            <div class="w-full flex items-end gap-2">
                <p-tabs [value]="selectedTabIndex().toString()" (valueChange)="handleTabChange($event)"
                    class="custom-tabview w-full">
                    <p-tablist>
                        @for(tab of projectKnowledgeTabs();let i = $index; track tab.id) {
                        <p-tab [value]="i.toString()" [disabled]="tab.disabled" [pTooltip]="tab.tooltip || ''"
                            [tooltipPosition]="'top'" [showDelay]="300" class="flex items-center !gap-2">
                            <div class="flex items-center gap-2">
                                <span class="text-gray-500 font-sans text-sm whitespace-nowrap">{{
                                    tab.label
                                    }}</span>
                            </div>
                        </p-tab>
                        }
                    </p-tablist>
                </p-tabs>
            </div>
        </div>
    </div>
    <div class="h-full">
        <!-- TODO: pass projectId to the files component -->
        @if(selectedTabIndex() === 0){
        <app-files [projectId]="projectId()" [scope]="KNOWLEDGE_SCOPE().PROJECT"></app-files>
        }@else if(selectedTabIndex() === 1){
        <app-knowledge-base-store [projectId]="projectId()"
            [scope]="KNOWLEDGE_SCOPE().PROJECT"></app-knowledge-base-store>
        }@else if(selectedTabIndex() === 2){
        <app-knowledge-mapping [projectId]="projectId()" [scope]="KNOWLEDGE_SCOPE().PROJECT"></app-knowledge-mapping>
        }
    </div>
</div>